import React from 'react';

const InstallSign = (props) => {
  return (
    <svg
      className={`iconTop ${props.className}`}
      width='120'
      height='120'
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M56 73c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='4.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='m61.392 93.534-2.28-1.823a35.46 35.46 0 0 1-4.189 0l-9.122 7.285a43.202 43.202 0 0 1-10.557-4.344L33.941 83.05a35.2 35.2 0 0 1-2.959-2.957l-11.607-1.36A43.062 43.062 0 0 1 15 68.183l7.29-9.122a35.45 35.45 0 0 1 0-4.187l-7.286-9.122a43.185 43.185 0 0 1 4.366-10.555l11.604-1.303a35.184 35.184 0 0 1 2.958-2.957l1.303-11.598A43.075 43.075 0 0 1 45.775 15l9.122 7.288a35.46 35.46 0 0 1 4.188 0l9.123-7.284a43.198 43.198 0 0 1 10.557 4.366l1.303 11.601a35.2 35.2 0 0 1 2.958 2.958l11.6 1.303A43.059 43.059 0 0 1 99 45.782l-7.29 9.122a35.45 35.45 0 0 1 0 4.187l1.822 2.28'
        stroke='#000'
        strokeWidth='4.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M89 69.2c10.916 0 19.8 8.884 19.8 19.8s-8.884 19.8-19.8 19.8S69.2 99.916 69.2 89 78.084 69.2 89 69.2z'
        stroke='#000'
        strokeWidth='4.4'
      />
      <path
        d='M87.625 78.495 89 95l1.375-16.505a1.38 1.38 0 1 0-2.75 0z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M91.5 100.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z' fill='var(--theme-primary, #810ea9)' />
    </svg>
  );
};

export default InstallSign;
